if (!customElements.get('journal-video')) {
  customElements.define(
    'journal-video',
    class extends HTMLElement {
      connectedCallback() {
        const trigger = this.querySelector('.jn-play');
        if (!trigger || !this.dataset.embed) return;

        trigger.addEventListener(
          'click',
          (event) => {
            event.preventDefault();

            const frame = document.createElement('iframe');
            frame.className = 'jn-video__frame';
            frame.src = this.dataset.embed;
            frame.title = this.dataset.title || '';
            frame.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
            frame.allowFullscreen = true;

            this.classList.add('is-playing');
            this.replaceChildren(frame);
          },
          { once: true }
        );
      }
    }
  );
}
